import { render, staticRenderFns } from "./QuestionSelectInput.vue?vue&type=template&id=47f80478"
import script from "./QuestionSelectInput.vue?vue&type=script&lang=js"
export * from "./QuestionSelectInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports